// extracted by mini-css-extract-plugin
export default {"plan-reading-container":"UI_plan-reading-container__ZbtDA","reading-price":"UI_reading-price__CFsMd","buy-button":"UI_buy-button__VllaC"};